module.exports = __webpack_public_path__ + "static/media/img3.92f323ce.jpg";